var spinner = require('commons/templates/Spinner.html');
var ladda   = require('ladda');

/**
 * @param {?(String|jQuery|Element)} button
 * @return {Function}
 */
function startFullScreen(button) {
    $(button)
        .addClass('ladda-button')
        .attr({'data-style': 'swap'});
    $.blockUI({
        message: null,
        overlayCSS: {
            backgroundColor: '#000',
            opacity: 0.2,
            cursor: null,
            'z-index': 1000000000
        }
    });

    let buttonEl = _.isObject($(button)) ? $(button)[0] : false;
    if (buttonEl) {
        var l = ladda.create(buttonEl);
        l.start();

        return function() {
            $(button).prop('disabled', false);
            $.unblockUI();
            l.stop();
        };
    }
    return function() {
        $(button).prop('disabled', false);
        $.unblockUI();
    };
}

/**
 * @param {?(String|jQuery|Element)} element
 * @return {Function}
 */
function startFullPage(element) {
    $.blockUI({
        message: null,
        overlayCSS: {
            backgroundColor: '#000',
            opacity: 0.2,
            cursor: null,
            'z-index': 1000000000
        }
    });
    $(element).html('<div class="loader">' + spinner() + '</div>');
    return function() {
        $.unblockUI();
    };
}

function stopLoader() {
    return $.unblockUI();
}

module.exports = {
    startFullScreen: startFullScreen,
    startFullPage:   startFullPage,
    stopLoader:      stopLoader
};



// WEBPACK FOOTER //
// ./app/helpers/loader.js